var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.$slots['default'])?_c(_vm.element,{tag:"component",staticClass:"xs-mb-20 xs-pb-10 b-b xs-pl-10 weight-book text-primary"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }